export const actionTypes = {
  LOG_LIST_REQUEST: 'LOG_LIST_REQUEST',
  LOG_LIST_SUCCESS: 'LOG_LIST_SUCCESS',
  LOG_LIST_FAILURE: 'LOG_LIST_FAILURE',
  LOG_LIST_CLEAR: 'LOG_LIST_CLEAR',
};
